export enum BonificationRefusedType {
  CUSTODIAN_NOT_FOUND = 'custodian_not_found',
  APPLICATION_NOT_FOUND = 'application_not_found',
  NOT_IN_TAX_HOUSEHOLD = 'not_in_tax_household',
  QUOTIENT_FAMILY_TOO_HIGH = 'quotient_familial_too_high',
  TOO_MANY_RETRIES = 'too_many_retries',
}
